import { createAsyncThunk } from "@reduxjs/toolkit";
import { getSellers } from "../../services/apiV2";
import { ISeller } from "./sellers.types";

export const getSellersThunk = createAsyncThunk(
  "sellers/getSellersThunk",
  async (ids: string[]) => {
    const { data: { sellers = [] } = {} } = await getSellers(ids);
    return sellers.map(
      ({ sellerId, sellerName, rating, ratingCount }) =>
        ({
          id: sellerId,
          name: sellerName,
          rating,
          ratingCount,
        }) as ISeller,
    );
  },
);
